// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_Ie6zn {
  position: relative;
  min-width: 46px;
  min-height: 46px;
  display: flex;
  flex-direction: column-reverse;
  gap: var(--size-padSmall);
  padding: var(--size-padMedium);
  background-color: var(--color-base700);
}

.hovered_wbsES {
  background-color: black;
}

.node_r2pY1 {
  display: inline-block !important;
  overflow: hidden;
  cursor: pointer;
  transform-origin: center;
}

.toggle_XH1FF {
  cursor: pointer;
}

.fixedPosition_XM3pF {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center;
  z-index: 0;
}

.fixedPosition_XM3pF div {
  justify-content: center;
}

.tooltip_h_67t {
  z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/actions/LayerToggle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".container {\n  position: relative;\n  min-width: 46px;\n  min-height: 46px;\n  display: flex;\n  flex-direction: column-reverse;\n  gap: var(--size-padSmall);\n  padding: var(--size-padMedium);\n  background-color: var(--color-base700);\n}\n\n.hovered {\n  background-color: black;\n}\n\n.node {\n  display: inline-block !important;\n  overflow: hidden;\n  cursor: pointer;\n  transform-origin: center;\n}\n\n.toggle {\n  cursor: pointer;\n}\n\n.fixedPosition {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center;\n  z-index: 0;\n}\n\n.fixedPosition div {\n  justify-content: center;\n}\n\n.tooltip {\n  z-index: 9999;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_Ie6zn`,
	"hovered": `hovered_wbsES`,
	"node": `node_r2pY1`,
	"toggle": `toggle_XH1FF`,
	"fixedPosition": `fixedPosition_XM3pF`,
	"tooltip": `tooltip_h_67t`
};
export default ___CSS_LOADER_EXPORT___;
